import { H1, H21, H2, H3, H4, H5, P, Span, Label, Blockquote, A, Link } from './Typography.style';

export { H1, H21, H2, H3, H4, H5, P, Span, Label, Blockquote, A, Link };
